import { getUrlParams, sanitizeHtml } from 'helpers/utils';
import { HrContribution, RulesContainer } from './styled';
import { useDisclaimerData } from 'hooks/donate';

export const ContributionRules = () => {
  const { urlPartner } = getUrlParams();
  const { customDisclaimer, isOathDisclaimerVisible } = useDisclaimerData();

  return (
    <RulesContainer>
      <HrContribution />
      {urlPartner?.includes('nonprofit') || urlPartner?.startsWith('np') ? (
        <>
          <div>
            All organizations on this page are non-profits and therefore these donations are
            tax-deductible. You will be emailed a receipt for your records.
          </div>
          <p>By proceeding with this transaction, you agree to Oath's terms & conditions.</p>
        </>
      ) : (
        <>
          {customDisclaimer && (
            <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(customDisclaimer) }} />
          )}
          {(isOathDisclaimerVisible || isOathDisclaimerVisible === undefined) && (
            <>
              <h2>Contribution Rules</h2>
              <ol>
                <li>
                  I attest that I meet all necessary contribution rules and criteria in all relevant
                  federal, state and local jurisdictions.
                </li>
                <li>
                  I am a U.S. citizen or lawfully admitted permanent resident (i.e., green card
                  holder).
                </li>
                <li>
                  This contribution is made from my own funds, and funds are not being provided to
                  me by another person or entity for the purpose of making this contribution.
                </li>
                <li>I am at least eighteen years old.</li>
                <li>
                  I am not a federal contractor.{' '}
                  <i>[Only applicable when donating to a Federal candidate or committee]</i>
                </li>
              </ol>
            </>
          )}
          <div>
            Oath does not share your contact information with any candidates or political parties.
          </div>
          <div>By proceeding with this transaction, you agree to Oath's terms & conditions.</div>
        </>
      )}
    </RulesContainer>
  );
};
